export function getTimeZoneName() {
  const targetTimeZone = localStorage.getItem("timezone");
  const now = new Date(); // Get the current date and time
  const options = {
    timeZone: targetTimeZone,
    timeZoneName: "short",
  };
  const formatter = new Intl.DateTimeFormat("en-US", options);
  const timeZoneInfo = formatter.formatToParts(now);
  let timeZoneName = null;
  for (const part of timeZoneInfo) {
    if (part.type === "timeZoneName") {
      timeZoneName = part.value;
    }
  }
  return timeZoneName;
}

export function calculateDate(dataDate) {
  const date = new Date(dataDate * 1000);
  const targetTimeZone =
    localStorage.getItem("timezone") && localStorage.getItem("timezone");
  const dateLocal = localStorage.getItem("lang") === "en" ? "en-US" : "de-De";

  let formatter = new Intl.DateTimeFormat(dateLocal, {
    timeZone: targetTimeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const localTime = formatter.format(date);

  // Check if the hour is 24 (midnight) and correct it to 00
  const hour = (
    date.getHours() === 24 ? "00" : date.getHours().toString()
  ).padStart(2, "0");

  formatter = new Intl.DateTimeFormat(dateLocal, {
    timeZone: targetTimeZone,
    hour12: false, // Display in 24-hour format
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const timePart = formatter.format(date);

  // Adjust the final_date format based on the language
  const final_date =
    dateLocal === "de-De"
      ? `${localTime.replace(/\//g, ".")} ${timePart}`
      : `${localTime}:${timePart}`;

  return final_date;
}

export function calculateLength(samplingRate, traceLength, preTriggerLength) {
  let trLength, preTrLength;
  if (samplingRate === 0) {
    trLength = traceLength / 4000;
    preTrLength = preTriggerLength / 4000;
  } else if (samplingRate === 1) {
    trLength = traceLength / 2000;
    preTrLength = preTriggerLength / 2000;
  } else if (samplingRate === 2) {
    trLength = traceLength / 1000;
    preTrLength = preTriggerLength / 1000;
  } else if (samplingRate === 3) {
    trLength = traceLength / 500;
    preTrLength = preTriggerLength / 500;
  } else if (samplingRate === 4) {
    trLength = traceLength / 250;
    preTrLength = preTriggerLength / 250;
  } else if (samplingRate === 5) {
    trLength = traceLength / 125;
    preTrLength = preTriggerLength / 125;
  } else if (samplingRate === 6) {
    trLength = traceLength / 62.5;
    preTrLength = preTriggerLength / 62.5;
  } else if (samplingRate === 7) {
    trLength = traceLength / 31.25;
    preTrLength = preTriggerLength / 31.25;
  } else if (samplingRate === 8) {
    trLength = traceLength / 15.625;
    preTrLength = preTriggerLength / 15.625;
  } else if (samplingRate === 9) {
    trLength = traceLength / 7.831;
    preTrLength = preTriggerLength / 7.831;
  } else if (samplingRate === 10) {
    trLength = traceLength / 3.906;
    preTrLength = preTriggerLength / 3.906;
  }

  return {
    trLength,
    preTrLength,
  };
}

export function getDecimalValue(value) {
  const updatedValue =
    localStorage.getItem("lang") === "en"
      ? value
      : value.toString().replace(/\./g, ",");
  return updatedValue;
}

export function checkAbsoluteValue(arr, target) {
  const targetAbs = Math.abs(target);
  const index = arr.findIndex((element) => Math.abs(element) === targetAbs);
  return index === -1 ? [false, -1] : index;
}
